import { TableCell } from "@mui/material";
import { useContext, useState } from "react";
import { Button, Modal } from "src/Components";
import {
  ICoveredCallOffsetTableReport,
  RollReport,
} from "src/Interfaces/coveredCall";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
import SendCCOrders from "./SendCCOrders";
import { Edit } from "@mui/icons-material";
import UpdateCriterion from "../../EnterPairPosition/Additional/UpdateCriterion";
import { ICCOrderLeg, IUpdateCriterionDTO, VolumeCalculationType } from "src/Interfaces/ccOrder";
import { DeltaHedgeOrderType } from "src/Interfaces/deltaHedgeOrder";
import { StepOrderSide } from "src/Interfaces/stepInterfaces";
import { CoveredCallOffsetContext } from "..";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">سفارش باز</span>
      </TableCell>
      <TableCell />
      <TableCell>
        <span className="!font-black text-black">کاربران</span>
      </TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: ICoveredCallOffsetTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  enum ModalMode {
    SendOrders,
    Edit,
    Closed,
  }
  const [modalMode, setModalMode] = useState(ModalMode.Closed);
  const { riskProfileId } = useContext(CoveredCallOffsetContext);

  function getInitialFormValues() {
    const res = {
      coveredCallOrderLegs: [] as ICCOrderLeg[],
      coveredCallOrderSellLeg: {} as ICCOrderLeg,
      orderType: DeltaHedgeOrderType.Offset,
      coveredCallPositionStrategyEnum: row.coveredCallPositionStrategyEnum,
      newCriterion: row.openOrdersCriterion
        ? Number(row.openOrdersCriterion)
        : 0,
      criterionType: row.openOrdersCriterionType,
    } as IUpdateCriterionDTO;

    res.coveredCallOrderLegs = [
      {
        instrumentId: row.baseInstrumentId,
        orderSide: StepOrderSide.Sell,
      },
    ];

    res.coveredCallOrderSellLeg = {
      instrumentId: row.sellInstrumentId,
      orderSide: StepOrderSide.Buy,
    };

    return res;
  }

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.SendOrders:
        return (
          <SendCCOrders
            onAction={() => {
              onAction();
              setModalMode(ModalMode.Closed);
            }}
            row={row}
            volumeCalculationType={VolumeCalculationType.Asset}
          />
        );

      case ModalMode.Edit:
        return (
          <UpdateCriterion
            instrumentNames={[row.baseInstrument!, row.baseInstrumentType!]}
            initialValues={getInitialFormValues()}
            onClose={() => setModalMode(ModalMode.Closed)}
            orderTypeStr="آفست"
            riskProfileId={riskProfileId}
          />
        );

      default:
        return <></>;
    }
  };

  const editHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setModalMode(ModalMode.Edit);
  };

  return (
    <>
      <TableCell>
        <div className="flex flex-row justify-start items-center gap-2">
          <div>{row.openOrderExpr || "-"}</div>
          {row.openOrderExpr ? (
            <div
              className="hover:bg-slate-300 transition-all rounded p-1 cursor-pointer"
              onClick={editHandler}
            >
              <Edit className="text-sky-700 cursor-pointer" />
            </div>
          ) : (
            <></>
          )}
        </div>
      </TableCell>
      <TableCell>
        {modalMode !== ModalMode.Closed ? (
          <Modal
            onClose={() => setModalMode(ModalMode.Closed)}
            UI={getModalUI()}
          />
        ) : (
          <></>
        )}
        <Button
          text="ارسال"
          variant="contained"
          onClick={() => setModalMode(ModalMode.SendOrders)}
        />
      </TableCell>
      <TableCell>{row.userNames}</TableCell>
    </>
  );
};

export const Additional: IAdditional<ICoveredCallOffsetTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
